import { HOME } from '../../constants';

export const FOOTER_LINK_FAMILIES = [
  {
    label: 'Quick Links',
    links: [
      { label: 'Home', path: HOME },
      { label: '#funeralApp', path: '#' },
      { label: 'Community', path: '#' },
    ],
  },
  {
    label: 'Products',
    links: [
      { label: 'Website', path: '#' },
      { label: 'Checkout', path: '#' },
      { label: 'Marketplace', path: '#' },
    ],
  },
  {
    label: 'About Us',
    links: [
      { label: 'Careers', path: '#' },
      { label: 'Live', path: '#' },
      { label: 'Webinars', path: '#' },
    ],
  },
];
